import React from "react";
import { Link } from "react-router-dom";
import { Calendar, MapPin, Users, Coins } from "lucide-react";
import SportIcon from "./SportIcon";

export function formatDateTime(iso, allDay = false) {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    if (allDay) {
      return d.toLocaleDateString(undefined, { weekday: "short", month: "short", day: "numeric" }) + " · All day";
    }
    return d.toLocaleString(undefined, { weekday: "short", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch { return iso; }
}

export function formatRange(start, end, allDay = false) {
  if (!start) return "";
  if (allDay) return formatDateTime(start, true);
  if (!end) return formatDateTime(start);
  try {
    const s = new Date(start), e = new Date(end);
    const sameDay = s.toDateString() === e.toDateString();
    if (sameDay) {
      return `${formatDateTime(start)} – ${e.toLocaleTimeString(undefined, { hour: "2-digit", minute: "2-digit" })}`;
    }
    return `${formatDateTime(start)} → ${formatDateTime(end)}`;
  } catch { return formatDateTime(start); }
}

export default function MatchCard({ match }) {
  const joined = match.players?.filter((p) => p.status === "joined").length || 0;
  const max = match.max_players || 4;
  const sportSlug = match.sport?.slug || "padel";
  return (
    <Link
      to={`/matches/${match.id}`}
      data-testid={`match-card-${match.id}`}
      className="pp-card block p-5 hover:border-[#00E676]/40 transition-all"
    >
      <div className="flex items-start justify-between">
        <div className="flex items-center gap-2">
          <div className="w-10 h-10 rounded-lg bg-[#00E676]/10 border border-[#00E676]/30 flex items-center justify-center text-[#00E676]">
            <SportIcon slug={sportSlug} size={20} />
          </div>
          <div>
            <div className="text-xs text-zinc-500 uppercase tracking-wider">{match.sport?.name || "Match"}</div>
            <div className="font-heading font-bold text-lg leading-tight">{match.title}</div>
          </div>
        </div>
        <div className={`pp-chip ${match.status === "open" ? "pp-chip-active" : ""}`}>{match.status}</div>
      </div>
      <div className="mt-4 grid grid-cols-2 gap-y-2 text-sm text-zinc-400">
        <div className="flex items-center gap-2"><Calendar size={14} /> {formatDateTime(match.start_time, match.all_day)}</div>
        <div className="flex items-center gap-2"><Users size={14} /> {joined}/{max}</div>
        <div className="flex items-center gap-2"><MapPin size={14} /> {match.club?.name || match.location || "—"}</div>
        <div className="flex items-center gap-2"><Coins size={14} /> {match.price_per_player > 0 ? `${match.price_per_player} ${match.currency}` : "Free"}</div>
      </div>
    </Link>
  );
}
